import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-physician-entrepreneurs-page',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, MatButtonModule],
  templateUrl: './physician-entrepreneurs-page.component.html',
  styleUrl: './physician-entrepreneurs-page.component.scss'
})
export class PhysicianEntrepreneursPageComponent {
  features = [
    { icon: 'person_search', title: 'Member directories', description: 'Searchable directories that help physicians find peers, collaborators, co-founders, and investors.' },
    { icon: 'event', title: 'Event registration', description: 'Run meetups, dinners, and conferences with simple registration and follow-up.' },
    { icon: 'lock', title: 'Private community access', description: 'Create gated spaces where members connect, share, and build relationships without the noise.' },
    { icon: 'payments', title: 'Paid memberships', description: 'Manage dues, tiers, and renewals that support sustainable community growth.' },
    { icon: 'account_tree', title: 'Chapter growth', description: 'Scale to new cities and regions without losing the core experience.' },
    { icon: 'forum', title: 'Networking and communication', description: 'Keep members informed, engaged, and connected between events.' }
  ];

  exampleCommunities = [
    { title: 'Women physician entrepreneur communities', description: 'Support member directories, events, and chapter growth for women physicians building businesses together.' },
    { title: 'Physician founder and startup networks', description: 'Bring founders, operators, and physician innovators together through private networks and event-driven communities.' },
    { title: 'Physician investor groups', description: 'Manage memberships, dinners, deal-sharing communities, and regional expansion for physician investor networks.' },
    { title: 'Practice owner communities', description: 'Support private groups for physicians growing independent practices, concierge medicine models, and business-focused peer networks.' }
  ];

  structuredPoints = [
    { title: 'More structure than a social platform', description: 'Organize memberships, renewals, and directories without stitching together multiple tools.' },
    { title: 'More community-focused than generic admin software', description: 'Support events, networking, and member connection with workflows built for growing communities.' },
    { title: 'Built to grow with your network', description: 'From a single city group to a multi-chapter physician community, MemberTrace helps you scale with consistency.' }
  ];
}
